import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2072Status: 'idle',
    startProcess2072Error: undefined as any,
    loadUserParamsProcess2072Status: 'idle',
    loadUserParamsProcess2072Error: undefined as any,

    process2072List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2072 = createAsyncThunk('process2072Slice/startProcess2072', async ({ process2072 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2072/`,
        prepareData(process2072),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2072Status } = getState().process2072Slice
        return startProcess2072Status !== 'pending'
    }
})

export const loadUserParamsProcess2072 = createAsyncThunk('process2072Slice/loadUserParamsProcess2072', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2072/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2072Status } = getState().process2072Slice
        return loadUserParamsProcess2072Status !== 'pending'
    }
})

const Process2072Slice = createSlice({
    name: 'process2072Slice',
    initialState,
    reducers: {
        resetstartProcess2072: (state) => {
            state.job = undefined
            state.startProcess2072Error = undefined
        },
        resetstartProcess2072Error: (state) => {
            state.startProcess2072Error = undefined
        },
        resetloadUserParamsProcess2072: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2072Error = undefined
        },
        resetloadUserParamsProcess2072Error: (state) => {
            state.loadUserParamsProcess2072Error = undefined
        },
        removeFromProcess2072ListById: (state, action) => {
            state.process2072List = state.process2072List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2072ListByIds: (state, action) => {
            state.process2072List = state.process2072List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2072List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2072Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2072List = []
            state.startProcess2072Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2072.pending, (state) => {
            state.startProcess2072Status = 'pending'
            state.startProcess2072Error = undefined
        })
        builder.addCase(startProcess2072.fulfilled, (state, action) => {
            state.startProcess2072Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2072.rejected, (state, action) => {
            state.startProcess2072Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2072Error = action.error.message
            } else {
                state.startProcess2072Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2072.pending, (state) => {
            state.loadUserParamsProcess2072Status = 'pending'
            state.loadUserParamsProcess2072Error = undefined
        })
        builder.addCase(loadUserParamsProcess2072.fulfilled, (state, action) => {
            state.loadUserParamsProcess2072Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2072.rejected, (state, action) => {
            state.loadUserParamsProcess2072Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2072Error = action.error.message
            } else {
                state.loadUserParamsProcess2072Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2072,
    resetstartProcess2072Error,
    resetloadUserParamsProcess2072,
    resetloadUserParamsProcess2072Error,
    removeFromProcess2072ListById,
    removeFromProcess2072ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2072Slice.actions
export default Process2072Slice.reducer
